import React from "react";
import { Link } from "react-router-dom";
import useSWR from "swr";
import { FormattedMessage } from "react-intl";
import { Button } from "./components/button";
import { fetcherWithToken } from "./fetcher-with-token";
import { secondaryButton, inputVariants } from "./components/button.css";
import {
  headerStyle,
  titleStyle,
  descriptionStyle,
  vagasLinkStyle,
  containerVagaCriada,
} from "./vaga-criada.css";
import { IlustracaoVagaCriada } from "./illustration/ilustracao-vaga-criada";
import { FeedbackCard } from "./components/feedback-card";
import { IlustracaoAutofalante } from "./illustration/ilustracao-autofalante";
import { IlustracaoAlvo } from "./illustration/ilustracao-alvo";
import { IlustracaoFolhaErro } from "./illustration/ilustracao-folha-erro";
import { Space } from "./components/space";
import SelectLoader from "./components/select-loader";
import { formatString } from "./utils/formatString";

export function VagaCriada({ formState, setFormState }) {
  React.useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const linkVaga = `${process.env.VAGAS}/v${formState.postResponse?.id_legado}`;

  const {
    data: candidatosRecomendadosData,
    error: candidatosRecomendadosError,
  } = useSWR(
    `${process.env.HESTIA}/sugestoes/profissionais-recomendados/${formState.postResponse?.id}`,
    fetcherWithToken
  );

  React.useEffect(() => {
    if (candidatosRecomendadosData)
      setFormState({ candidatosRecomendadosData });
    if (candidatosRecomendadosError)
      setFormState({ candidatosRecomendadosError });
  }, [candidatosRecomendadosData, candidatosRecomendadosError]);

  return (
    <div className={containerVagaCriada}>
      <Space />
      <div className={headerStyle}>
        <IlustracaoVagaCriada />
        <Space />
        <h1 className={titleStyle}>
          {" "}
          <FormattedMessage
            id="vagaCriada.processoAberto"
            defaultMessage="Processo seletivo aberto!"
          />
        </h1>
        <p className={descriptionStyle}>
          <FormattedMessage
            id="vagaCriada.infoCargo"
            defaultMessage="Seu processo seletivo, {cargo}, está aberto. O que você
          gostaria de fazer agora?"
            values={{ cargo: formatString(formState.cargo) }}
          />
        </p>
      </div>
      <FeedbackCard
        icon={<IlustracaoAutofalante />}
        title={formatString(formState.cargo)}
        description={
          <FormattedMessage
            id="vagaCriada.titleLinkVaga"
            defaultMessage="Este é o link da sua vaga. Compartilhe!"
          />
        }
        secondaryText={linkVaga}
        actions={
          <Button
            className={`${secondaryButton} ${inputVariants["transition-buttons"]}`}
            onClick={() => {
              navigator.clipboard.writeText(linkVaga);
            }}
          >
            <FormattedMessage
              id="vagaCriada.copiarLinkVaga"
              defaultMessage="Copiar link da vaga"
            />
          </Button>
        }
      ></FeedbackCard>
      <Space />

      {!candidatosRecomendadosData ? (
        <SelectLoader height={524} />
      ) : (
        <>
          {candidatosRecomendadosData.total_de_profissionais ? (
            <>
              <FeedbackCard
                icon={<IlustracaoAlvo />}
                title={
                  <FormattedMessage
                    id="vagaCriada.title"
                    defaultMessage="Ganhe tempo!"
                  />
                }
                description={
                  <FormattedMessage
                    id="vagaCriada.recomendados"
                    defaultMessage="Nossa inteligência artificial
                  selecionou profissionais para você. Avalie-os e inclua-os em seu
                  processo seletivo!"
                  />
                }
                actions={
                  <a
                    href={`${process.env.GLOBAL_URL}/vagas/recomendados/${formState.postResponse?.id}`}
                    className={vagasLinkStyle}
                  >
                    <FormattedMessage
                      id="vagaCriada.verRecomendados"
                      defaultMessage="Ver recomendados"
                      description="Link que direciona o usuário para uma lista de candidatos que foram recomendados para uma vaga"
                    />
                  </a>
                }
              ></FeedbackCard>
            </>
          ) : (
            <FeedbackCard
              icon={<IlustracaoFolhaErro />}
              title={
                <FormattedMessage
                  id="vagaCriada.titleSemRecomendados"
                  defaultMessage="Sentimos muito, mas não conseguimos fazer a recomendação de
                profissionais..."
                />
              }
              description={
                <FormattedMessage
                  id="vagaCriada.descriptionSemRecomendados"
                  defaultMessage="Não se preocupe! Temos muitas formas de
                fazer os melhores profissionais encontrarem a sua vaga. Fique de
                olho!"
                />
              }
            ></FeedbackCard>
          )}
        </>
      )}

      <Space />
      <a href={`${process.env.GLOBAL_URL}/vagas`} className={vagasLinkStyle}>
        <FormattedMessage
          id="vagaCriada.linkMinhasVagas"
          defaultMessage="Ir para as minhas vagas"
        />
      </a>
    </div>
  );
}
